import React, { Component } from 'react';
import Header from '../.././Header';
import Image from '../.././Image';
import classnames from 'classnames';

export default class Surveylicious extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;

    const navLinks = [
      {path: "/projects", title: "Projects"}
    ]

    const slug = "surveylicious";
    const screenshots = [
      {id: 'surveylicious-1', title: 'Surveylicious', content: 'A cursive font that exemplifies the fun nature of the brand, placed across a pink checkered ribbon that adds color and personality. The seams along the edges of the ribbon provide a dimension of texture. Font used: Ballpark.'},
      {id: 'surveylicious-2', title: 'For Customers', content: 'The main landing page shows the interface of the mobile application being used, contrasted against a blurred and distant background. The value proposition is straightforward with a clear call to action for users to sign up.'},
      {id: 'surveylicious-3', title: 'For Businesses', content: 'The landing page for businesses shows prominently the value of the application to business owners with a clear call to action to register. Screenshots serve as accompanying visual aids.'},
      {id: 'surveylicious-4', title: 'Survey Dashboard', content: 'The survey dashboard adopts a two-panel interface. The details of the survey, such as location and number of responses, are shown on the left, while the results of each question are summarized on the right.'},
      {id: 'surveylicious-5', title: 'Pie Charts', content: 'The results of multiple choice questions are displayed in the form of pie charts as they can be quickly understood visually. The breakdown in percentages is also included in the legend.'},
      {id: 'surveylicious-6', title: 'Response Data', content: 'A clean table view to display each survey response. The blue ribbons add more color and vibrancy against the light grey background.'},
      {id: 'surveylicious-7', title: 'Mobile Survey Interface', content: 'The mobile survey interface is visually consistent with the theme and design of the website, adopting panels for information clustering. A distinct pink band indicates which options have been selected for each question.'},
      {id: 'surveylicious-8', title: 'Mobile Post-Survey Interface', content: 'Upon completion of each survey, the user receives various feedback cues that acknowledges the effort and time put in, such as a customizable thank-you message as well as badges and rewards.'},
    ];

    return (
      <div className={classnames('Surveylicious', className)}>
        <Header links={navLinks} />
        <div className="container">
          <div className="section">
            <div className="section-content">
              <div className="section-header">Surveylicious</div>
              <div className="section-title">Description</div>
              <div className="section-copy">
                <ul>
                  <li><strong>Objective</strong>: Help businesses collect and respond to customer feedback, as well as develop insights about their products and services</li>
                  <li><strong>Role</strong>: Co-founder, designer and developer</li>
                  <li><strong>Team</strong>: Amanda Lim, Julian Koo</li>
                  <li><strong>Duration</strong>: Jan 2011—Apr 2012 (1 year 4 months)</li>
                </ul>
              </div>
              <div className="section-title">Highlights</div>
              <div className="section-copy">
                <ul>
                  <li>Launched a mobile web application for businesses and customers</li>
                  <li>Won BASES Entrepreneurship Bootcamp 2011</li>
                  <li>Received the Innovation and Entrepreneurship Practicum Grant from National University of Singapore</li>
                  <li>Gathered over 1K responses during a beta trial in Stanford University with Stanford Dining and eateries on campus</li>
                </ul>
              </div>
              <div className="section-title">Summary</div>
              <div className="section-copy">
                <p>
                  Surveylicious is a mobile survey application that helps business owners collect feedback from their customers. I started this venture with Amanda Lim and Julian Koo in 2011 as part of Tom Kosnik{'\'s'} New Venture Creation class at Stanford University. As the technical co-founder, I was responsible for both the design and development of the product.
                </p>
                <p>
                  <strong>Problem:</strong> As foreign students, we ate out often when we first arrived, and we soon realized that many restaurants use paper comment cards to get feedback from their customers. Feedback is important for restaurants, yet collecting via comment cards is inefficient. It is difficult for restaurants to print and manually collate the results, and it can be tedious for customers to fill them out at the end of a meal too.
                </p>
                <p>
                  <strong>Approach:</strong> We sought to solve this problem by developing an application that allows businesses to easily create location-based surveys, with multiple-choice and open-ended questions, and view the feedback in real-time. Customers can easily give feedback via a unique link for the business. Overall, the vision for Surveylicious was to be a mobile customer relationships management tool for businesses.
                </p>
                <p>
                  We conducted a trial with a number of eateries at Stanford University, including CoHo and Stanford Dining. We also tested the application at a number of events. We left the bay area at the end of 2011 and tried to roll out Surveylicious in Singapore. However, businesses in Singapore did not care as much about feedback, and the concept did not really take off.
                </p>
              </div>
              <div className="section-title">Designs</div>
              <div className="section-images">
                {
                  Object.keys(screenshots).map(function(key) {
                    return (
                      <Image slug={slug} id={screenshots[key]['id']} title={screenshots[key]['title']} content={screenshots[key]['content']} />
                    )
                  })
                }
              </div>
              <div className="section-title">Tech / Tools</div>
              <div className="section-copy">
                <ul>
                  <li>Designed in Adobe Photoshop</li>
                  <li>Built with Ruby on Rails, jQuery, HAML and SASS</li>
                  <li>Integrated SendGrid, Twilio and Google Chart APIs</li>
                  <li>Tracked usage with Google Analytics and Mixpanel</li>
                  <li>Hosted on Heroku and Amazon Web Services</li>
                </ul>
              </div>
              <div className="section-title">Press</div>
              <div className="section-copy">
                <ul>
                  <li><a href="http://newshub.nus.edu.sg/news/1203/PDF/OVERSEAS-asiaone%20edvantage-9mar.pdf">Campus spotlight: Overseas experience nurtures award-winning start-up</a></li>
                  <li><a href="http://www.xconomy.com/san-francisco/2011/04/09/will-one-of-these-be-the-next-google-student-entrepreneurs-compete-at-stanford-video/">Will One of These Be the Next Google? Student Entrepreneurs Compete at Stanford</a></li>
                  <li><a href="https://www.techinasia.com/surveylicious-scouts-nyc/">Surveylicious Scouts NYC</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/Surveylicious/index.js